import {BaseEntityUnDeletable} from '../../../common/entities';

export class InterviewOutcome extends BaseEntityUnDeletable {
    description: string;
    isHired: boolean;
}
